import {
  BANK_STATEMENT_LINE_SOURCE_TYPE_TO_MODEL_TYPE,
  DOCUMENT_MAIN_TYPE,
  MODEL_PHASE_TYPE,
  MODEL_TYPE
} from '../constants/index.jsx'
import enumConstants from './../enumConstants.json'
import { DOCUMENT_HELPER } from './document.jsx'

export const BANK_STATEMENT_HELPER = {
  DOCUMENT: {
    bankStatementSourceApplyConfig: (config, entityModelId, sourceType) => {
      const modelType = BANK_STATEMENT_LINE_SOURCE_TYPE_TO_MODEL_TYPE[sourceType]

      const filters = [
        ['account_id', '=', entityModelId]
      ]

      if (DOCUMENT_HELPER.lineHasShipping(modelType)) {
        filters.push(['status_phase_type', 'in', [MODEL_PHASE_TYPE.APPROVED]])
      } else {
        filters.push(['status_phase_type', 'in', [MODEL_PHASE_TYPE.CLOSED, MODEL_PHASE_TYPE.POSTED]])
        filters.push(['payment_status', 'in', [enumConstants.document_payment_statuses.NOT_PAID, enumConstants.document_payment_statuses.PARTIALLY_PAID]])
      }

      config.params.filter.push(filters)
    },
    bankStatementSourceApplyData: (data, model) => {
      const isCredit = [
        MODEL_TYPE.SALES_INVOICE,
        MODEL_TYPE.SALES_ORDER,
        MODEL_TYPE.PURCHASE_ADVANCE_INVOICE,
        MODEL_TYPE.PURCHASE_CREDIT_MEMO,
        MODEL_TYPE.PURCHASE_RETURN_ORDER,
        MODEL_TYPE.SALES_FINANCE_CHARGE,
        MODEL_TYPE.SERVICE_INVOICE,
        MODEL_TYPE.SERVICE_ORDER
      ].includes(model.type)

      const amount = model.main_type === DOCUMENT_MAIN_TYPE.PURCHASE
        ? model.external_document_amount
        : model.total

      data.debit = isCredit ? 0 : amount
      data.credit = isCredit ? amount : 0

      data.source_model_date = model.date
      data.source_model_due_date = model.due_date
      data.source_model_ext_source_no = model.external_document_number
      data.source_model_ext_source_date = model.external_document_date

      data.amount = amount

      data.location_id = model.location_id
      data.location = model.location
      data.responsibility_center_id = model.responsibility_center_id
      data.responsibility_center = model.responsibility_center
    }
  }
}
